<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ "catalogo web" | capitalize }}</h1>
      <b-button
        class="is-primary"
        slot="trigger"
        icon-right="content-save-outline"
        @click="updateCatalog()"
      />
      <b-field label="Controlla se un modello è in lista">
        <b-autocomplete
          clearable
          v-model="selectedModel"
          placeholder="modello"
          :data="filteredDataObj"
          field="name"
          @blur="checkValidity()"
        ></b-autocomplete>
      </b-field>
      <b-field v-for="(model, index) in catalog" v-bind:key="index">
        <b-input size="is-small" v-model="model.name"></b-input>
        <b-input size="is-small" v-model="model.color"></b-input>
        <b-button class="is-danger" size="is-small" @click="removeModel(index)"
          >rimuovi modello</b-button
        >
      </b-field>
      <b-button class="is-primary" size="is-small" @click="addModel()"
        >aggiungi modello</b-button
      >
    </div>
  </section>
</template>

<script>
import permissionMixin from "@/helpers/mixins/permissionMixin";
export default {
  name: "webCatalog",
  mixins: [permissionMixin],
  data() {
    return {
      catalog: [],
      selectedModel: ""
    };
  },
  methods: {
    addModel() {
      this.catalog.push({ name: "", color: "" });
    },
    removeModel(index) {
      this.catalog.splice(index, 1);
    },
    updateCatalog() {
      if (
        this.catalog.filter(model => {
          return model.name.length == 0;
        }).length == 0
      ) {
        this.$db
          .collection("extras")
          .doc("web_catalog")
          .update({ web_catalog: this.catalog })
          .then(() => {
            this.savedConfirm();
          });
      } else {
        this.updateError();
      }
    },
    savedConfirm() {
      this.$buefy.toast.open({
        message: "OK",
        type: "is-success"
      });
    },
    updateError() {
      this.$buefy.toast.open({ message: "Error", type: "is-danger" });
    },
    checkValidity() {
      if (
        this.catalog.filter(model => {
          return model.name == this.selectedModel;
        }).length == 0
      ) {
        this.selectedModel = "";
      }
    }
  },
  computed: {
    filteredDataObj() {
      return this.catalog.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.selectedModel.toLowerCase()) >= 0
        );
      });
    }
  },
  mounted() {
    let isAllowed = false;
    switch (this.userInfo.type) {
      case "A":
        isAllowed = true;
        break;
      case "I":
        if (this.userInfo.level == "S" || this.userInfo.level == "2")
          isAllowed = true;
        break;
    }
    if (!isAllowed) this.$router.push("/forbidden");
    this.$db
      .collection("extras")
      .doc("web_catalog")
      .get()
      .then(doc => {
        this.catalog = doc.data().web_catalog;
      });
  }
};
</script>>
